import{KEY_PREFIX as e}from"./constants.js";function t(t){var r=t.storage,n="".concat(void 0!==t.keyPrefix?t.keyPrefix:e).concat(t.key);return r.removeItem(n,o)}function o(e){0}export{t as default};
//# sourceMappingURL=purgeStoredState.js.map
